import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ItinInfoService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetItinInfo(itin: string | undefined): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const itinparams: JSON = <JSON>(<unknown>{
      itincode: itin,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      //'https://localhost:44386/' + 'GetItinInfo',
      this.OBPortalSvcURL + 'GetItinInfo',
      JSON.stringify(itinparams),
      { headers: headers }
    );
  }
}
